import { render } from "./Footer.vue?vue&type=template&id=6f0048a2&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=6f0048a2&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0048a2"]])

export default __exports__